import { createAvatarWrapper } from '@/modules/misc/common/navbar/components/avatar';
import {
  createLinks,
  createSwitchAccountButtons,
  LINKS_TYPE,
  switchAccounts,
} from '@/modules/misc/common/navbar/components/navbarLinks';
import breakpointConfig from '@/modules/misc/common/navbar/linksPosition/breakpointConfig.json';
import getLinksPosition from '@/modules/misc/common/navbar/linksPosition/getLinksPosition';
import { deleteChildNodes } from '@/modules/misc/common/navbar/utils/deleteChildNodes';

const navbarBreakpointConfig = {
  ...breakpointConfig,
  ...(window._NAVBAR_BREAKPOINT_CONFIG || {}),
};

export function createNavbar({ links, user, showDot = false }) {
  const navbarWrapper = document.querySelector('.ds-header__navbar');
  if (!navbarWrapper) {
    return;
  }
  navbarWrapper.style.display = 'none'; // hide navbar to measure screen width correctly
  const {
    navLinks,
    dropdownLinks,
    dotAllowed,
  } = getLinksPosition({ links, user, config: navbarBreakpointConfig });
  navbarWrapper.removeAttribute('style');

  deleteChildNodes(navbarWrapper);

  if (navLinks.length) {
    navbarWrapper.appendChild(createLinks({
      links: navLinks,
      className: 'ds-header__navbar__main-nav',
      linksType: LINKS_TYPE.STATIC_NAV,
    }));
  }

  if (dropdownLinks.length) {
    const divider = document.createElement('span');
    divider.classList.add('ds-header__navbar__divider');
    navbarWrapper.appendChild(divider);

    navbarWrapper.appendChild(createAvatarWrapper({
      className: 'ds-header__navbar__avatar',
      user,
      links: dropdownLinks,
      dotAllowed,
      showDot,
    }));
  }

  if (user?.canSwitchAccounts) {
    const dropdown = document.querySelector('.ds-header__navbar__avatar__dropdown');
    dropdown.appendChild(createSwitchAccountButtons({ user }));
    dropdown.style.paddingBottom = '0px';

    if (user.type === 'user') {
      document.getElementById('switchToManagerAccount').addEventListener('click', switchAccounts);
    } else if (user.type === 'manager') {
      document.getElementById('switchToUserAccount').addEventListener('click', switchAccounts);
    }
  }
}
